export const category_type = [
    {
        label:'首页分类',
        value:'home'
    },
    {
        label:'列表分类',
        value:'list'
    },
    {
        label:'其他分类',
        value:'other'
    }
]